var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWorklairSupportWidget = function SvgWorklairSupportWidget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151 109"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.29 0h-27L53.05 52.95l18-4.77-15.88 31.77c-3.12-6.15-27.6-56.59-27.6-56.59H0l47.36 85.88 51.22-81.18-16.81 5.03zm22.77 23.36-22.5 42.25L91.8 48.85 80.31 67.06l22.84 42.25 47.5-85.95z",
    className: "worklair-support-widget_svg__currentLayer"
  })));
};
export default SvgWorklairSupportWidget;